import React from 'react';
import { CaretRightIcon } from 'assets/icons';
import { getAmountWithCurrency } from 'utils/amountUtils';
import { InvoiceByIdV2, InvoiceStatus } from '../invoices.model';
import { VoidFn } from 'types/baseTypes';
import DateUtils from 'utils/dateUtils';
import If from 'components/If/If';

interface InvoiceAmountHeaderProps {
  invoiceData: InvoiceByIdV2;
  handleCollectPartialAmountClick?: VoidFn;
}

export const InvoiceAmountHeader: React.FC<InvoiceAmountHeaderProps> = ({
  invoiceData,
  handleCollectPartialAmountClick
}) => {
  const taxesAndFees = Number(invoiceData?.totalAmount) - Number(invoiceData?.subTotalAmount);
  const showAmountSubtext = taxesAndFees > 0 && invoiceData?.pendingAmount === invoiceData?.totalAmount;
  const dueDate = invoiceData?.invoiceDueDate ? DateUtils.parseISODateString(invoiceData?.invoiceDueDate) : '';
  const formattedDueDate = dueDate ? DateUtils.getDateInFormat({ date: dueDate, dateFormat: 'MMM dd, yyyy' }) : '';

  return (
    <div className="flex w-full flex-col items-center gap-1 border-b border-borderGray pb-5">
      <div className="text-sbase font-bold text-primaryText">Payment due on {formattedDueDate}</div>
      <div className="py-3 text-4xl font-bold text-headingBlack">
        {getAmountWithCurrency(invoiceData?.pendingAmount)}
      </div>
      {showAmountSubtext && (
        <div className="text-[15px] text-primaryText">
          {getAmountWithCurrency(invoiceData.subTotalAmount)} + {getAmountWithCurrency(taxesAndFees)} Taxes & fees
        </div>
      )}
      <If condition={invoiceData?.partialPaymentEnabled && invoiceData?.status !== InvoiceStatus.PAID}>
        <button
          id="collect-partial-amount-button"
          onClick={handleCollectPartialAmountClick}
          className="flex cursor-pointer items-center gap-1 pt-5 text-sbase font-semibold text-secondary ">
          Collect a partial amount
          <span>
            <CaretRightIcon className="path path-fill-current mt-0.5 h-4 w-4 text-secondary" />
          </span>
        </button>
      </If>
    </div>
  );
};
